module.exports = __webpack_public_path__ + "static/media/9DESA26.e2707a89.jpg";